<app-loading />
<app-modal />

<app-header
  [isAuthenticated]="authService.isAuthenticated()"
  [userName]="authService.principal()?.name"
  [breadcrumb]="breadcrumb"
  [sidebarCollapsed]="sidebarCollapsed"
  (toggleSidebar)="toggleSidebar()"
  (onSignIn)="signIn()"
  (onSignOut)="signOut()" />

<div class="flex pt-14 min-h-screen bg-maersk-bg-page">
  @if (authService.isAuthenticated()) {
    <app-sidebar
      [isOpen]="sidebarOpen"
      [isCollapsed]="sidebarCollapsed"
      (linkClicked)="closeSidebar()" />

    @if (sidebarOpen) {
      <button
        type="button"
        class="fixed inset-0 top-14 z-30 bg-black/35 md:hidden"
        aria-label="Close navigation"
        (click)="closeSidebar()"></button>
    }
  }

  <main
    class="flex-1 overflow-y-auto p-4 transition-[margin] duration-200 sm:p-6 lg:p-8"
    [class.md:ml-60]="authService.isAuthenticated() && !sidebarCollapsed"
    [class.md:ml-16]="authService.isAuthenticated() && sidebarCollapsed">
    <router-outlet />
  </main>
</div>

<app-notifications />
